import emailjs from "@emailjs/browser";
import "../App.css";
import { useRef } from "react";
import { useState } from "react";
import { ImFacebook2, ImInstagram, ImTwitter } from "react-icons/im";
import { HiOutlinePhoneIncoming, HiOutlineMail } from "react-icons/hi";
import { MdDoneOutline } from "react-icons/md";
function Footer() {
  const [emailSend, setemailSend] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [messege, setMessege] = useState("");
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    if (email.length === 0 || name.length === 0 || messege.length === 0) {
      return;
    }
    setemailSend(false);

    emailjs
      .sendForm(
        "service_kdw07vw",
        "template_67gc4kg",
        form.current,
        "TZNH0ViEvZFH7-CdG"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div className="parentFooter">
      <div className="footer">
        {emailSend ? (
          <form ref={form} onSubmit={sendEmail}>
            <h1 className="footerHead">Contact us </h1>
            <p>Name</p>
            <input
              onChange={(e) => setName(e.target.value)}
              type="text"
              name="user_name"
            />
            <p>Email</p>
            <input
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              name="user_email"
            />
            <p>Message</p>
            <textarea
              onChange={(e) => setMessege(e.target.value)}
              name="message"
            />
            <br></br>
            <button className="submit">Send</button>
          </form>
        ) : (
          <h1 className="thankyou">
            Email sent successfully
            <MdDoneOutline />
          </h1>
        )}

        <div className="socialMeida">
          <h1 className="thankyou2">We will be 24/7 at your service</h1>
          <div>
            <p className="contactInfo">
              <HiOutlinePhoneIncoming /> 404-924-0799 ~ English
            </p>
            <p className="contactInfo">
              <HiOutlinePhoneIncoming /> 404-513-3731 ~ Espaniol
            </p>
            <p className="contactInfo">
              <HiOutlineMail className="icon2" /> teamyyummytacos@gmail.com
            </p>
          </div>
          <div className="icons">
            <a href="https://www.facebook.com/profile.php?id=100093680523392&mibextid=LQQJ4d">
              <ImFacebook2 className="icon" />
            </a>
            <a href="https://yummytacos.netlify.app/">
              <ImInstagram className="icon" />
            </a>
            <a href="https://yummytacos.netlify.app/">
              {" "}
              <ImTwitter className="icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
